<template>
  <div>
    <input type="hidden" :value="date" :name="name" style="display: hidden;" />
    <date-pick
      v-model="date"
      :inputAttributes="{ id, name: `date-${name}`, autocomplete: 'off' }"
      :format="'YYYY-MM-DD'"
      :displayFormat="format"
      :parseDate="parseDate"
      :formatDate="formatDate"
      :weekdays="weekdays"
      :months="months"
      :isDateDisabled="dateDisabled"
      :editable="isEditable"
      autocomplete="off"></date-pick>
  </div>
</template>

<script>
import DatePick from 'vue-date-pick'
import fecha from 'fecha'
import 'vue-date-pick/dist/vueDatePick.css'

export default {
  components: { DatePick },

  props: {
    id: String,
    name: String,
    inputValue: String,
    weekdays: {
      type: Array,
      default: () => ([
          'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'
      ])
    },
    months: {
      type: Array,
      default: () => ([
        'janvier', 'février', 'mars', 'avril',
        'mai', 'juin', 'juillet', 'août',
        'septembre', 'octobre', 'novembre', 'décembre'
      ])
    },
    noFuture: {
      type: Boolean,
      default: false,
    },
    noPast: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: String,
      default: "0",
    },
  },

  data () {
    return {
      format: 'DD MMMM YYYY',
      date: '',
    }
  },

  computed: {
    isEditable() {
      return this.disabled === '1' ? false : true
    }
  },

  mounted() {
    fecha.i18n.monthNames = this.months
    this.date = this.inputValue
  },

  methods: {
    parseDate(dateString, format) {
        return fecha.parse(dateString, format);
    },
    formatDate(dateObj, format) {
        return fecha.format(dateObj, format);
    },
    dateDisabled (date) {
      if (this.noPast) {
        return this.isBeforeDate(date)
      }

      if (this.noFuture) {
        return this.isFutureDate(date)
      }

      return false
    },
    isBeforeDate(date) {
        if (this.noPast) {
          const currentDate = new Date();

          return date < currentDate;
        }

        return false;
    },
    isFutureDate(date) {
        if (this.noFuture) {
          const currentDate = new Date();

          return date > currentDate;
        }

        return false;
    },
  }
}
</script>

<style lang="scss">
.vdpComponent.vdpWithInput {
  width: 100%;

  > input {
    display: block;
    width: 100%;
    height: calc(1.6em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
}
</style>
